import { jsx } from 'react/jsx-runtime';
import { createContext, useContext, useState, useRef, useEffect } from 'react';

const RetryPaymentContext = createContext({
    setRetryPaymentInfo: () => { },
    retryPaymentInfo: {
        retryPossible: true,
    },
});
const useRetryPaymentContext = () => {
    const context = useContext(RetryPaymentContext);
    return context;
};
const RetryPaymentContextProvider = ({ children, retryPossible: retryPossibleInit, retryPaymentStatus: retryPaymentStatusInit, }) => {
    const [retryPaymentInfo, setRetryPaymentInfo] = useState({
        retryPossible: retryPossibleInit,
        retryPaymentStatus: retryPaymentStatusInit,
    });
    const firstRender = useRef(true);
    useEffect(() => {
        if (!firstRender.current) {
            setRetryPaymentInfo({
                retryPossible: retryPossibleInit,
                retryPaymentStatus: retryPaymentStatusInit,
            });
        }
        firstRender.current = false;
    }, [retryPossibleInit, retryPaymentStatusInit]);
    return (jsx(RetryPaymentContext.Provider, { value: {
            retryPaymentInfo,
            setRetryPaymentInfo,
        }, children: children }));
};

export { RetryPaymentContextProvider as default, useRetryPaymentContext };
//# sourceMappingURL=RetryPaymentContextProvider.js.map
